import React from 'react';
import {styled, keyframes} from '@mui/material/styles';
import {designSystemToken} from '@lightricks/react-design-system';

export type CircleLoaderProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Size mapping for the loader
const sizeMap = {
  small: '2em',
  medium: '2.5em',
  large: '2.7em',
};

// Styled component for the circle loader
const StyledCircleLoader = styled('div')<{size: 'small' | 'medium' | 'large'}>(
  ({size}) => ({
    width: sizeMap[size],
    height: sizeMap[size],
    fontSize: '10px',
    position: 'relative',
    textIndent: '-9999em',
    borderRadius: '50%',
    borderTop: `0.2em solid ${designSystemToken('semantic.bg.alpha')}`,
    borderRight: `0.2em solid ${designSystemToken('semantic.bg.alpha')}`,
    borderBottom: `0.2em solid ${designSystemToken('semantic.bg.alpha')}`,
    borderLeft: `0.2em solid ${designSystemToken('semantic.fg.primary')}`,
    transform: 'translateZ(0)',
    animation: `${spinAnimation} 1.1s infinite linear`,
  })
);

/**
 * CircleLoader - A circular loading spinner component
 *
 * @param size - The size of the loader (small, medium, large)
 * @param className - Additional CSS class name
 */
function CircleLoader({size = 'medium', className}: CircleLoaderProps) {
  return <StyledCircleLoader size={size} className={className} />;
}

export default CircleLoader;
